import React from "react";

function InvestmentSolutions() {
  return (
    <section
      className="service_section pt-5 pb-5"
      data-aos="fade-up"
      data-aos-easing="linear"
      data-aos-duration="400"
    >
      {/* <img src="/images//cta-bg1.jpg" alt="" />
      <img src="/public/cta-bg2.jpg" alt="" /> */}

      <div className="circle_one"></div>
      <div className="circle_two"></div>
      <div className="container">
        <div className="section_title light centred">
          <h2 className="text-white">Our Intelligent Financial Solutions</h2>
          <p className="text-white">
            Transform your financial journey with cutting-edge AI technology and
            personalized strategies designed to maximize your wealth potential.
          </p>
        </div>

        <div className="row">
          {/* Loan Arrangement */}
          <div className="col-xl-4 col-md-6 col-sm-12">
            <div
              className="service_block_one"
              data-aos="fade-up"
              data-aos-easing="linear"
              data-aos-duration="500"
              data-aos-delay="100"
            >
              <div className="service_icon">
                <i className="fa-solid fa-landmark"></i>
              </div>
              <h4 className="text-white">Loan Arrangement</h4>
              <p className="text-white">
                Our proprietary algorithms analyze thousands of loan options in
                seconds to match you with the perfect financing solution.
              </p>
            </div>
          </div>

          {/* Crypto Investment */}
          <div className="col-xl-4 col-md-6 col-sm-12">
            <div
              className="service_block_one"
              data-aos="fade-up"
              data-aos-easing="linear"
              data-aos-duration="500"
              data-aos-delay="200"
            >
              <div className="service_icon">
                <i className="fa-brands fa-bitcoin"></i>
              </div>
              <h4 className="text-white">Crypto Investment</h4>
              <p className="text-white">
                Simplify cryptocurrency investing with AI‑powered insights.
                Navigate markets confidently, reduce risks.
              </p>
            </div>
          </div>

          {/* Automated Trading */}
          <div className="col-xl-4 col-md-6 col-sm-12">
            <div
              className="service_block_one"
              data-aos="fade-up"
              data-aos-easing="linear"
              data-aos-duration="500"
              data-aos-delay="300"
            >
              <div className="service_icon">
                <i className="fa-solid fa-robot"></i>
              </div>
              <h4 className="text-white">Automated Trading</h4>
              <p className="text-white">
                Execute precision trades confidently with our advanced
                algorithmic trading systems, delivering speed, accuracy, smarter
                decisions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default InvestmentSolutions;
